/** SPA routes; static files live under /img/… and never under these prefixes. */
export const WORKSPACE_BASE = "/onderzoek";

export const paths = {
  home: (): string => "/",
  workspace: (): string => WORKSPACE_BASE,

  lands: (): string => `${WORKSPACE_BASE}/gebieden`,
  newLand: (): string => `${WORKSPACE_BASE}/gebieden/nieuw`,
  land: (id: string): string => `${WORKSPACE_BASE}/gebieden/${id}`,
  editLand: (id: string): string => `${WORKSPACE_BASE}/gebieden/${id}/bewerken`,

  samples: (): string => `${WORKSPACE_BASE}/monsters`,
  /** Optional land preselected in the form (`?gebied=<landId>`). */
  newSample: (landId?: string): string =>
    `${WORKSPACE_BASE}/monsters/nieuw${landId ? `?gebied=${encodeURIComponent(landId)}` : ""}`,
  sample: (id: string): string => `${WORKSPACE_BASE}/monsters/${id}`,
  editSample: (id: string): string => `${WORKSPACE_BASE}/monsters/${id}/bewerken`,

  researchList: (): string => `${WORKSPACE_BASE}/onderzoeken`,
  research: (id: string): string => `${WORKSPACE_BASE}/onderzoeken/${id}`,
  editResearch: (id: string): string => `${WORKSPACE_BASE}/onderzoeken/${id}/bewerken`,

  adviceList: (): string => `${WORKSPACE_BASE}/adviezen`,
  advice: (id: string): string => `${WORKSPACE_BASE}/adviezen/${id}`,
  editAdvice: (id: string): string => `${WORKSPACE_BASE}/adviezen/${id}/bewerken`,

  lab: (): string => `${WORKSPACE_BASE}/lab`,
  users: (): string => `${WORKSPACE_BASE}/gebruikers`,
};

/** Query parameter of paths.newSample(). */
export const NEW_SAMPLE_LAND_PARAM = "gebied";
